// 未发送、签署中、已完成、已撤回、已拒绝、已失败、未读、已读
export enum contractSignStatusName {
  unSend = '未发送',
  signing = '签署中',
  finish = '已完成',
  revoke = '已撤回',
  reject = '已拒绝',
  overdue = '已过期',
  fail = '已失败',
  nullify = '已解约'
}

export enum contractStatusValue {
  unSend = 70,
  signing = 10,
  finish = 20,
  revoke = 30,
  reject = 40,
  overdue = 50,
  fail = 60,
  nullify = 80
}

export const contractStatusList = [
  { label: contractSignStatusName.unSend, value: contractStatusValue.unSend },
  { label: contractSignStatusName.signing, value: contractStatusValue.signing },
  { label: contractSignStatusName.finish, value: contractStatusValue.finish },
  { label: contractSignStatusName.revoke, value: contractStatusValue.revoke },
  { label: contractSignStatusName.reject, value: contractStatusValue.reject },
  { label: contractSignStatusName.overdue, value: contractStatusValue.overdue },
  { label: contractSignStatusName.fail, value: contractStatusValue.fail }
]

// 合同字段与关联表单对象的映射值格式
export const mappingRule = /{.*}/
